export default {
  computed: {
    isNotification() {
      return this.$store.getters.getExportFile &&
        this.$store.getters.getExportFile.steptype &&
        this.$store.getters.getExportFile.steptype === 23;
    },
  },
};